import { a as allCountries } from '../constants/countryLists-Ck89Ck3L.js';

const sanitizeCountries = countryList => countryList.filter(country => allCountries.includes(country));

export { sanitizeCountries as s };
//# sourceMappingURL=sanitizeCountries-_TWllG0n.js.map
